import apiUser from "../../api";
import {
  accountFilterFields,
  activityFilterFields,
  companyFilterField,
  designationFilterField,
  settledRows,
  userFullName,
} from "../../features/user.filter";

// Advanced filter for the clients list (see ../../features/user.filter.js).
export const clientFilterFields = [
  companyFilterField,
  designationFilterField,
  { key: "trade_of_work_fids", label: "Trade of Work", type: "select", group: "Organization", optionsKey: "trades", optionLabel: "trade_name" },
  { key: "business_type_fid", label: "Business Type", type: "select", group: "Organization", optionsKey: "businessTypes", optionLabel: "name" },
  { key: "assigned_admin_fid", label: "Assigned Admin", type: "select", group: "Organization", optionsKey: "admins", optionLabelFormatter: userFullName },
  ...accountFilterFields,
  ...activityFilterFields,
];

// Dropdown data for the filter, fetched once when the drawer first opens.
export const loadClientFilterDependencies = async () => {
  const [companiesRes, designationsRes, tradesRes, businessTypesRes, adminsRes] = await Promise.allSettled([
    apiUser.getCompanies(),
    apiUser.getDesignations(),
    apiUser.getTrades(),
    apiUser.getBusinessTypes(),
    apiUser.getAllClients({ role: "ADMIN" }),
  ]);

  return {
    companies: settledRows(companiesRes),
    designations: settledRows(designationsRes),
    trades: settledRows(tradesRes),
    businessTypes: settledRows(businessTypesRes),
    admins: settledRows(adminsRes),
  };
};
